import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "headline" }
const _hoisted_2 = { style: {"height":"75vh","overflow":"auto"} }
const _hoisted_3 = { style: {"min-width":"40px"} }
const _hoisted_4 = { style: {"font-weight":"bold"} }
const _hoisted_5 = {
  key: 0,
  style: {"display":"block","font-style":"italic"}
}
const _hoisted_6 = {
  key: 1,
  style: {"display":"block","font-style":"italic"}
}
const _hoisted_7 = { style: {"font-weight":"bold"} }
const _hoisted_8 = {
  key: 0,
  style: {"display":"block","font-style":"italic"}
}
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_AccountableAccount = _resolveComponent("AccountableAccount")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_ScopeManager = _resolveComponent("ScopeManager")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_company_table = _resolveComponent("company-table")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    class: "pb-0 mb-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "default_card large mx-0 my-2 pa-2 fill-height sticky-card",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: _ctx.enablePublish || _ctx.enablehUnpublish ? '8' : '10'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    class: "mr-4",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.warnUser()), ["stop"]))
                  }),
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, {
                cols: _ctx.enablePublish || _ctx.enablehUnpublish ? '4' : '2',
                class: "d-flex justify-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    rounded: "",
                    elevation: "0",
                    class: _normalizeClass(["ml-2", { 'animate-attention': !_ctx.isDisabled }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.upload())),
                    disabled: _ctx.isDisabled,
                    "data-cy": "WordingAnalysisEdition-creer",
                    ref: "leBoutton"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.patternId ? "Modifier" : "Créer"), 1)
                    ]),
                    _: 1
                  }, 8, ["class", "disabled"])
                ]),
                _: 1
              }, 8, ["cols"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_card, { class: "scrolled-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-flex justify-start align-center pb-2"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("wording-analysis.conditions")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specs.patternSpec, (cont, index) => {
              return (_openBlock(), _createBlock(_component_v_row, {
                "no-gutters": "",
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "1",
                    class: "d-flex align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(index !== 0 ? "ET" : "SI"), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_col, {
                    cols: "2",
                    class: "py-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        modelValue: cont.operator,
                        "onUpdate:modelValue": ($event: any) => ((cont.operator) = $event),
                        items: _ctx.operators,
                        outlined: "",
                        "hide-details": true,
                        readonly: _ctx.readonly,
                        "data-cy": "WordingAnalysisEdition-contOperator",
                        density: "compact",
                        "item-title": "text",
                        "item-value": "value"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "readonly"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_col, {
                    cols: "8",
                    class: "py-2 pl-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_combobox_filled, {
                        modelValue: cont.words,
                        "onUpdate:modelValue": ($event: any) => ((cont.words) = $event),
                        label: _ctx.$t('wording-analysis.un-de-ces-mots'),
                        multiple: "",
                        chips: "",
                        "no-filter": "",
                        "hide-details": "",
                        "item-disabled": "",
                        readonly: _ctx.readonly,
                        "data-cy": "WordingAnalysisEdition-remplace"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "readonly"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_col, {
                    col: "1",
                    class: "d-flex align-center justify-space-between ml-2"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.specs.patternSpec.length > 1)
                        ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                            key: 0,
                            size: "x-small",
                            onClick: ($event: any) => (_ctx.removeCondition(index)),
                            disabled: _ctx.readonly
                          }, null, 8, ["onClick", "disabled"]))
                        : _createCommentVNode("", true),
                      (index + 1 === _ctx.specs.patternSpec.length)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            size: "x-small",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addCondition())),
                            disabled: _ctx.readonly,
                            icon: "$add"
                          }, null, 8, ["disabled"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "mt-2 justify-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_divider)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "d-flex align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      label: _ctx.$t('wording-analysis.montant-min'),
                      disabled: !_ctx.defineMinAmount,
                      readonly: _ctx.readonly,
                      modelValue: _ctx.minAmount,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.minAmount) = $event))
                    }, null, 8, ["label", "disabled", "readonly", "modelValue"]),
                    _createVNode(_component_v_checkbox, {
                      class: "mx-2",
                      color: "green",
                      modelValue: _ctx.defineMinAmount,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.defineMinAmount) = $event)),
                      readonly: _ctx.readonly
                    }, null, 8, ["modelValue", "readonly"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "d-flex align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      label: _ctx.$t('wording-analysis.montant-max'),
                      disabled: !_ctx.defineMaxAmount,
                      readonly: _ctx.readonly,
                      modelValue: _ctx.maxAmount,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.maxAmount) = $event))
                    }, null, 8, ["label", "disabled", "readonly", "modelValue"]),
                    _createVNode(_component_v_checkbox, {
                      class: "mx-2",
                      color: "green",
                      modelValue: _ctx.defineMaxAmount,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.defineMaxAmount) = $event)),
                      readonly: _ctx.readonly
                    }, null, 8, ["modelValue", "readonly"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_card, { class: "scrolled-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-flex justify-start align-center pb-2"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("wording-analysis.modification-libelle")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.specs.rules.outputWording,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.specs.rules.outputWording) = $event)),
                      label: _ctx.$t('wording-analysis.libelle-remp'),
                      outlined: "",
                      "hide-details": "",
                      readonly: _ctx.readonly,
                      "data-cy": "WordingAnalysisEdition-specsOutputWording",
                      density: "compact"
                    }, null, 8, ["modelValue", "label", "readonly"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "11" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "title pt-4"
                        }, {
                          default: _withCtx(() => _cache[37] || (_cache[37] = [
                            _createTextVNode(" Compte tiers ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              modelValue: _ctx.specs.rules.thirdPartyOnly,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.specs.rules.thirdPartyOnly) = $event)),
                              label: _ctx.$t('wording-analysis.activer'),
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggleRule('thirdPartyOnly'))),
                              readonly: _ctx.readonly,
                              "data-cy": "WordingAnalysisEdition-specsThirdPartyOnly"
                            }, null, 8, ["modelValue", "label", "readonly"])
                          ]),
                          _: 1
                        }),
                        (_ctx.assignedCompanyCount !== 1 || !_ctx.uniqueAssignedCompanyId)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "5"
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_AccountableAccount, {
                                  showLabel: true,
                                  label: ' ',
                                  showValidation: false,
                                  showDescription: true,
                                  inAccountableAccounts: _ctx.accountableAccountsCFSTF,
                                  inAccountableAccount: _ctx.specs.rules.thirdPartyAccountableAccount,
                                  disabled: !_ctx.specs.rules.thirdPartyOnly || _ctx.readonly,
                                  hideDetails: true,
                                  onSelectAccountableAccount: _ctx.selectThirdPartyAccountableAccount,
                                  defineThirdParty: true,
                                  "data-cy": "WordingAnalysisEdition-accountableAccountSpecsThirdPartyOnly"
                                }, null, 8, ["inAccountableAccounts", "inAccountableAccount", "disabled", "onSelectAccountableAccount"]), [
                                  [_vShow, true]
                                ])
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "5"
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_AccountableAccount, {
                                  showLabel: true,
                                  label: ' ',
                                  showValidation: false,
                                  showDescription: true,
                                  companyId: _ctx.uniqueAssignedCompanyId,
                                  thirdParty: 
                                        _ctx.specs.thirdParty ||
                                        _ctx.specs.thirdPartyCompany ||
                                        _ctx.specs.thirdPartyUser
                                    ,
                                  inAccountableAccounts: _ctx.accountableAccountsCFSTF,
                                  inAccountableAccount: _ctx.specs.rules.thirdPartyAccountableAccount,
                                  disabled: !_ctx.specs.rules.thirdPartyOnly || _ctx.readonly,
                                  hideDetails: true,
                                  onSelectAccountableAccount: _ctx.selectThirdPartyAccountableAccount,
                                  defineThirdParty: true,
                                  "data-cy": "WordingAnalysisEdition-accountableAccountSpecsThirdPartyOnly"
                                }, null, 8, ["companyId", "thirdParty", "inAccountableAccounts", "inAccountableAccount", "disabled", "onSelectAccountableAccount"]), [
                                  [_vShow, true]
                                ])
                              ]),
                              _: 1
                            })),
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "d-flex align-center pl-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_component_v_text_field_filled, {
                              readonly: "",
                              outlined: "",
                              key: _ctx.specs.id,
                              label: _ctx.$t('wording-analysis.tiers'),
                              "hide-details": "",
                              disabled: "",
                              "model-value": _ctx.thirdPartyTitle,
                              density: "compact"
                            }, null, 8, ["label", "model-value"]))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "title pt-4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("wording-analysis.affectation")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              modelValue: _ctx.specs.rules.withoutInvoice,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.specs.rules.withoutInvoice) = $event)),
                              label: _ctx.$t('wording-analysis.activer'),
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleRule('withoutInvoice'))),
                              readonly: _ctx.readonly,
                              "data-cy": "WordingAnalysisEdition-specsWithoutInvoice"
                            }, null, 8, ["modelValue", "label", "readonly"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: _ctx.displayVatRate ? 5 : 10
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_AccountableAccount, {
                              showLabel: true,
                              showValidation: false,
                              showDescription: true,
                              companyId: _ctx.uniqueAssignedCompanyId,
                              inAccountableAccounts: _ctx.purchaseAndSalesAAs,
                              inAccountableAccount: _ctx.specs.rules.accountableAccount,
                              disabled: !_ctx.specs.rules.withoutInvoice || _ctx.readonly,
                              hideDetails: true,
                              onSelectAccountableAccount: _ctx.selectAccountableAccount,
                              "data-cy": "WordingAnalysisEdition-accountableAccountSpecsWithoutInvoice"
                            }, null, 8, ["companyId", "inAccountableAccounts", "inAccountableAccount", "disabled", "onSelectAccountableAccount"]), [
                              [_vShow, true]
                            ])
                          ]),
                          _: 1
                        }, 8, ["cols"]),
                        (_ctx.displayVatRate)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 2,
                              cols: "5",
                              class: "d-flex align-center pl-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select_filled, {
                                  modelValue: _ctx.vat,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.vat) = $event)),
                                  items: _ctx.vats,
                                  label: "Le taux de TVA à appliquer",
                                  "return-object": "",
                                  "hide-details": ""
                                }, null, 8, ["modelValue", "items"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "title pt-4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("wording-analysis.sans-facture")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              modelValue: _ctx.specs.rules.withoutInvoiceWithThirdParty,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.specs.rules.withoutInvoiceWithThirdParty) = $event)),
                              label: _ctx.$t('wording-analysis.activer'),
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.toggleRule('withoutInvoiceWithThirdParty'))),
                              readonly: _ctx.readonly,
                              "data-cy": "WordingAnalysisEdition-specsWithoutInvoiceWithThirdParty"
                            }, null, 8, ["modelValue", "label", "readonly"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "5" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_AccountableAccount, {
                              showLabel: true,
                              showValidation: false,
                              showDescription: true,
                              companyId: _ctx.uniqueAssignedCompanyId,
                              inAccountableAccounts: _ctx.purchaseAndSalesAAs,
                              inAccountableAccount: _ctx.specs.rules.accountableAccount,
                              disabled: 
                                        !_ctx.specs.rules.withoutInvoiceWithThirdParty || _ctx.readonly
                                    ,
                              hideDetails: true,
                              onSelectAccountableAccount: _ctx.selectAccountableAccount,
                              "data-cy": "WordingAnalysisEdition-accountableAccountSpecsWithoutInvoiceWithThirdParty"
                            }, null, 8, ["companyId", "inAccountableAccounts", "inAccountableAccount", "disabled", "onSelectAccountableAccount"]), [
                              [_vShow, true]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "d-flex align-center pl-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              readonly: "",
                              outlined: "",
                              label: _ctx.$t('wording-analysis.societe-tiers'),
                              "hide-details": "",
                              disabled: !_ctx.thirdPartyCompanyIsRequired,
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogSelectCompany = !_ctx.dialogSelectCompany)),
                              "data-cy": "WordingAnalysisEdition-societeTiers",
                              "model-value": 
                                        _ctx.specs.thirdPartyCompany && _ctx.specs.thirdPartyCompany.name
                                            ? _ctx.specs.thirdPartyCompany.name
                                            : ''
                                    ,
                              density: "compact"
                            }, null, 8, ["label", "disabled", "model-value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "title pt-4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("wording-analysis.encaissement")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              modelValue: _ctx.specs.rules.salesInvoiceAuto,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.specs.rules.salesInvoiceAuto) = $event)),
                              label: _ctx.$t('wording-analysis.activer'),
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.toggleRule('salesInvoiceAuto'))),
                              readonly: _ctx.readonly,
                              "data-cy": "WordingAnalysisEdition-specsSalesInvoiceAuto"
                            }, null, 8, ["modelValue", "label", "readonly"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "10" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_AccountableAccount, {
                              showLabel: true,
                              showValidation: false,
                              showDescription: true,
                              companyId: _ctx.uniqueAssignedCompanyId,
                              inAccountableAccounts: _ctx.salesAAs,
                              inAccountableAccount: _ctx.specs.rules.accountableAccount,
                              disabled: !_ctx.specs.rules.salesInvoiceAuto || _ctx.readonly,
                              hideDetails: true,
                              onSelectAccountableAccount: _ctx.selectAccountableAccount,
                              "data-cy": "WordingAnalysisEdition-accountableAccountSpecsSalesInvoiceAuto"
                            }, null, 8, ["companyId", "inAccountableAccounts", "inAccountableAccount", "disabled", "onSelectAccountableAccount"]), [
                              [_vShow, true]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "title pt-4"
                        }, {
                          default: _withCtx(() => _cache[38] || (_cache[38] = [
                            _createTextVNode(" Z de caisse ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              modelValue: _ctx.specs.rules.zTillReceipt,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.specs.rules.zTillReceipt) = $event)),
                              label: _ctx.$t('wording-analysis.activer'),
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.toggleRule('ztillReceipt'))),
                              readonly: _ctx.readonly,
                              "data-cy": "WordingAnalysisEdition-specsZTillReceipt"
                            }, null, 8, ["modelValue", "label", "readonly"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "px-3 pt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-flex justify-start align-center pb-2"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("wording-analysis.etiquettes")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-flex align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_combobox_filled, {
                      modelValue: _ctx.specs.rules.tags,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.specs.rules.tags) = $event)),
                      multiple: "",
                      density: "compact",
                      chips: "",
                      "closable-chips": "",
                      "item-disabled": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_card, { class: "scrolled-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-flex justify-start align-center pb-2"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("wording-analysis.test-libelle")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-flex align-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      (_ctx.wordingTest && !_ctx.regexEmpty)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            color: _ctx.testResult ? 'green' : 'red'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.testResult ? "$fa-thumbs-up" : "$fa-thumbs-down"), 1)
                            ]),
                            _: 1
                          }, 8, ["color"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.wordingTest,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.wordingTest) = $event)),
                      outlined: "",
                      "hide-details": "",
                      label: "Test",
                      "data-cy": "WordingAnalysisEdition-test",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "d-flex justify-center mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-flex justify-start align-center py-2"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("wording-analysis.simulation")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "8",
                  class: "d-flex"
                }, {
                  default: _withCtx(() => [
                    _cache[39] || (_cache[39] = _createElementVNode("div", { style: {"min-width":"40px"} }, null, -1)),
                    _createVNode(_component_v_select_filled, {
                      modelValue: _ctx.scopedCompanyId,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.scopedCompanyId) = $event)),
                      items: _ctx.scopedCompanies,
                      "item-value": "id",
                      outlined: "",
                      "hide-details": false,
                      readonly: _ctx.readonly,
                      "data-cy": "WordingAnalysisEdition-scopedCompanyId",
                      density: "compact",
                      class: "mr-3",
                      "item-title": (item) => item.name
                    }, null, 8, ["modelValue", "items", "readonly", "item-title"]),
                    _createVNode(_component_v_btn, {
                      class: "mx-3 mt-2",
                      rounded: "",
                      elevation: "0",
                      disabled: _ctx.regexEmpty || !_ctx.scopedCompanyId,
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.simulatingWordingBTAnalysis(_ctx.wordingTest))),
                      "data-cy": "WordingAnalysisEdition-simulation",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("wording-analysis.simuler")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "d-flex justify-start"
                }, {
                  default: _withCtx(() => [
                    (_ctx.displaySimulationResult)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                              _createVNode(_component_v_btn, {
                                rounded: "",
                                color: "primary",
                                class: "mx-3 mt-2",
                                elevation: "0",
                                disabled: 
                                            _ctx.readonly ||
                                            !_ctx.simulateWordingBTAnalysis ||
                                            _ctx.simulateWordingBTAnalysis.length === 0 ||
                                            _ctx.isDisabled
                                        ,
                                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.applySimulationDialog = true)),
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("wording-analysis.appliquer")), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ], 16)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("wording-analysis.appliquer-regle")), 1),
                            (
                                    _ctx.simulateWordingBTAnalysis &&
                                    _ctx.simulateWordingBTAnalysis.length === 0
                                )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("wording-analysis.aucun-releve")), 1))
                              : (_ctx.isDisabled)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("wording-analysis.donner-regle")), 1))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.scopedCompanies && _ctx.scopedCompanies.length > 1)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 1,
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createElementVNode("div", _mergeProps(props, { class: "pl-1" }), [
                              _createVNode(_component_v_btn, {
                                rounded: "",
                                color: "primary",
                                class: "ml-3 mt-2",
                                elevation: "0",
                                disabled: _ctx.readonly || _ctx.isDisabled,
                                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.applyOnCompaniesDialog = true)),
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("wording-analysis.appliquer-societes")), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ], 16)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("wording-analysis.appliquer-societes", {
                                        count: _ctx.scopedCompanies.length,
                                    })), 1),
                            (_ctx.isDisabled)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("wording-analysis.pensez")), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.displaySimulationResult)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  "no-gutters": "",
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-start align-center pb-2"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("wording-analysis.resultats")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "pt-2 d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_data_table, {
                          headers: _ctx.headers,
                          items: _ctx.formatedSimulateWordingBTAnalysis,
                          "items-per-page": 20,
                          loading: _ctx.simulationLoading,
                          "hide-default-header": "",
                          class: "elevation-0 table",
                          density: "compact"
                        }, {
                          item: _withCtx((props) => [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", null, _toDisplayString(props.item.wordingDisplay || props.item.wordingOriginal), 1),
                              _createElementVNode("td", null, _toDisplayString(props.item.amount), 1),
                              _createElementVNode("td", _hoisted_9, _toDisplayString(props.item.date), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["headers", "items", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ScopeManager, {
          ref: "scopeManager",
          modelValue: _ctx.scopeSync,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.scopeSync) = $event)),
          id: _ctx.scopeId,
          "onUpdate:id": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.scopeId) = $event)),
          name: _ctx.scopeName,
          "onUpdate:name": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.scopeName) = $event)),
          readonly: _ctx.readonly,
          initialCompany: _ctx.initialCompany,
          returnScopedCompanies: true,
          onScopedCompanies: _ctx.onScopedCompaniesChanged
        }, null, 8, ["modelValue", "id", "name", "readonly", "initialCompany", "onScopedCompanies"])
      ]),
      _createVNode(_component_v_snackbar, {
        modelValue: _ctx.alertApplyingSimulationSuccess,
        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.alertApplyingSimulationSuccess) = $event)),
        color: "success"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            color: "white",
            timeout: "6000",
            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.alertApplyingSimulationSuccess = false)),
            variant: "text"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("wording-analysis.fermer")), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("wording-analysis.modifs-appliques")) + " ", 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_snackbar, {
        modelValue: _ctx.snackbarActive,
        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.snackbarActive) = $event))
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.snackbarActive = false)),
            variant: "text"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("wording-analysis.fermer")), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.snackbarText) + " ", 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.dialogSelectCompany)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 0,
            modelValue: _ctx.dialogSelectCompany,
            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.dialogSelectCompany) = $event)),
            title: _ctx.$t('wording-analysis.choissiz-societe-tiers'),
            width: "800px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_company_table, {
                showGenericCompany: false,
                showNewCompanies: true,
                "show-customer-companies": 
                    _ctx.uniqueAssignedCompanyId &&
                    _ctx.specs.rules &&
                    _ctx.specs.rules.accountableAccount &&
                    _ctx.specs.rules.accountableAccount.name &&
                    _ctx.specs.rules.accountableAccount.name.startsWith('7')
                ,
                "show-supplier-companies": 
                    _ctx.uniqueAssignedCompanyId &&
                    _ctx.specs.rules &&
                    _ctx.specs.rules.accountableAccount &&
                    _ctx.specs.rules.accountableAccount.name &&
                    _ctx.specs.rules.accountableAccount.name.startsWith('6')
                ,
                showExistingCompanies: !_ctx.uniqueAssignedCompanyId,
                "parent-company-id": _ctx.uniqueAssignedCompanyId,
                wizardMode: true,
                onSelectCompany: _ctx.companySelected
              }, null, 8, ["show-customer-companies", "show-supplier-companies", "showExistingCompanies", "parent-company-id", "onSelectCompany"])
            ]),
            _: 1
          }, 8, ["modelValue", "title"]))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.applySimulationDialog,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.applySimulationDialog) = $event)),
        title: _ctx.$t('wording-analysis.appliquer-modifs'),
        onValid: _cache[35] || (_cache[35] = ($event: any) => (_ctx.applyingSimulation())),
        validLoading: _ctx.applySimulationDialogLoading,
        width: "800px"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.confirmationMessage), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "title", "validLoading"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.areYouSureDialog,
        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.areYouSureDialog) = $event)),
        "data-cy": "oss-dialog-are-you-sure",
        title: _ctx.$t('wording-analysis.sans-enregistrer'),
        width: "800px"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            style: {"min-width":"30vw"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pr-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    rounded: "",
                    block: "",
                    onClick: _ctx.onYesDialog,
                    "data-cy": "clicking-yes-button",
                    size: "x-large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("wording-analysis.oui")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    rounded: "",
                    block: "",
                    onClick: _ctx.onNoDialog,
                    size: "x-large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("wording-analysis.non")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _: 1
  }))
}